var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-bottom-navigation',{staticStyle:{"position":"sticky"},attrs:{"color":"primary","horizontal":""}},[_vm._l((_vm.items),function(item){return [_c('v-btn',{key:item.path,attrs:{"to":item.path}},[_c('span',{key:item.title},[_vm._v(_vm._s(item.title))]),_c('v-icon',{key:item.icon},[_vm._v(_vm._s(item.icon))])],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }